import React, {useState, useContext, useEffect, Fragment} from 'react';
import classes from './EmailSubmit.module.scss';
import Button from '../UI/Button/Button';
import axios from '../../axios-instance';
import moment from 'moment';

const EmailSubmit = props => {
    const { history, title, description, source_type, source_id, device_uuid, redirect} = props;
    const [enteredEmail, setEnteredEmail] = useState('');
    const [enteredFirstName, setEnteredFirstName] = useState('');
    const [enteredLastName, setEnteredLastName] = useState('');
    const [enteredPhoneNumber, setEnteredPhoneNumber] = useState('');
    const [emalMarketingOptIn, setEmailMarketingOptIn] = useState(false);
    const [formSubmit, setFormSubmit] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(null);
    const [alreadySubscribed, setAlreadySubscribed] = useState(null);
    const [showEmailError, setShowEmailError] = useState({        
        value: false,
        retryFunc: null
    });
    
    const emailSubmitHandler = (e) => {
        e.preventDefault();
        setFormSubmit(true);
    }

    useEffect(() => {

        const onPostEmailSubscription = async() => {
            const payload = {
                source_type: source_type,
                source_id: source_id,
                email: enteredEmail,
                first_name: enteredFirstName,
                last_name: enteredLastName,
                phone_number: enteredPhoneNumber,
                email_marketing_opt_in: emalMarketingOptIn,
                restriction : {
                    enabled : true,
                    amount : 1,
                    period : 'daily', 
                    timezone : "America/Los_Angeles"
                }
            }

            try {
                const res = await axios.post(`user/subscribe`, payload, {
                    headers: {'x-device-uuid': `${device_uuid}`}
                });

                if (res && (res.status === 201)) {
                    window.location.href = redirect + '&subscription_id=' + res.data.subscription_id;
                }

                if (res && (res.status === 200)) {
                    setAlreadySubscribed(true);
                }
            } catch(err) {
                setShowEmailError({
                    value: true,
                    retryFunc: onPostEmailSubscription
                })
            }
        }
        if (formSubmit) {            
            onPostEmailSubscription();
        }
    }, [formSubmit, enteredEmail, source_type, source_id, device_uuid, enteredFirstName, enteredLastName, enteredPhoneNumber, redirect, emalMarketingOptIn])

    const handleFollowClick = () => {
        // Track impression via event
        //window.location.href="";
    }

    const emailSubmitFormContainer = (  
        <form id="submit-form" className={classes.FormContainer} onSubmit={emailSubmitHandler}>
            <div className={classes.FormSubmitDescription}>{description}</div>
            <div className={classes.FormInputContainer}>
                <div>
                    <label htmlFor="firstName">First Name*</label>
                </div>
                <input
                    required
                    autoComplete="true"
                    name="firstName"
                    type="text"
                    //placeholder="John"
                    className={classes.EmailInput}
                    onChange={event => setEnteredFirstName(event.target.value)} />
            </div>

            <div className={classes.FormInputContainer}>
                <div>
                    <label htmlFor="lastName">Last Name*</label>
                </div>
                <input
                    name="lastName"
                    required
                    autoComplete="true"
                    type="text"
                    //placeholder="Smith"
                    className={classes.EmailInput}
                    onChange={event => setEnteredLastName(event.target.value)} />
            </div>

            <div className={classes.FormInputContainer}>
                <div>
                    <label htmlFor="email">Email Address*</label>
                </div>
                <input
                    name="email"
                    required
                    autoComplete="false"
                    type="email"
                    placeholder="emailaddress@actv8me.com"
                    className={classes.EmailInput}
                    onChange={event => setEnteredEmail(event.target.value)} />
            </div>

            <div className={classes.FormInputContainer} style={{marginBottom: '5px'}}>
                <div>
                    <label htmlFor="phone">Phone Number (Optional)</label>
                </div>
                <input
                    name="phone"
                    autoComplete="false"
                    type="tel"
                    pattern="[0-9]{3}[0-9]{3}[0-9]{4}"
                    placeholder="(000) 000-0000"
                    className={classes.EmailInput}
                    onChange={event => setEnteredPhoneNumber(event.target.value)} />

            </div>

            <div className={classes.SweepstakesContainer}>
                <input
                    required
                    className={classes.SweepstakesCheck}
                    type="checkbox"
                    id="sweepstakes-rules" />

                <label htmlFor="sweepstakes-rules" className={classes.CheckboxLabel} style={{fontWeight: '400', lineHeight: '24px'}}>
                    I have read and agree to the <a href="https://actv8me-public-assets-production.s3.amazonaws.com/downloadable/tpn/FINAL_TPN_Oikos_Family_Reunion_Promotion_Official_Rules_11_03_22.pdf">Official Rules</a> &amp; <a href="https://www.danonenorthamerica.com/privacy-policy">Privacy Policy</a>
                </label>

            </div>

            <div className={classes.SweepstakesContainer}>
                <input
                    className={classes.SweepstakesCheck}
                    type="checkbox"
                    id="marketing-opt-in" 
                    onChange={(event => setEmailMarketingOptIn(event.target.value))}
                    />

                <label htmlFor="marketing-opt-in" className={classes.CheckboxLabel} style={{fontWeight: '400', lineHeight: '24px'}}>
                    I agree to receive future marketing emails from Oikos
                </label>
            </div>
    
            <div className={classes.ButtonContainer}>
                <Button btnText={'SUBMIT ENTRY'} backgroundColor={'#3B4761'}/>
            </div>
        </form>
    );

    const footer = (
        <div className={classes.Footer}> &copy; 2022 ACTV8me, Inc. <br/> 
            <a href="https://actv8me-public-assets-production.s3.amazonaws.com/downloadable/tpn/FINAL_TPN_Oikos_Family_Reunion_Promotion_Official_Rules_11_03_22.pdf">Official Rules </a> | <a href="https://actv8me-public-assets-production.s3.amazonaws.com/downloadable/tpn/FINAL_TPN_Oikos_Family_Reunion_Promotion_Official_Rules_11_03_22.pdf">Terms of Service</a> | <a href="https://www.danonenorthamerica.com/privacy-policy">Privacy Policy</a>
        </div>
    )

    const followButton = (
        <div className={classes.ButtonContainer}>
            <Button btnText={''} color={'#181748'} onClick={handleFollowClick}/>
        </div>  
    );

    const alreadyEntered = (
        <Fragment>
            <div className={classes.FormContainer} style={{backgroundColor: "black", color: "white", width: "100%", height:"542px"}}>
                <div className={classes.SubmitTitle} style={{color: "white", marginTop: '30px', width: '92%'}}>
                    Looks like you already made your entry today!
                </div>
                <div className={classes.SubmitDescription} style={{height: '140px', width: "90%", color: "white", fontWeight: '400', marginTop: '0px'}}>
                    <p>You may enter once per day. Try your luck again tomorrow and you could win.</p>
                    <p style={{marginTop: '35px'}}><strong>Scan Again Tomorrow!</strong></p>
                </div>
            </div>
        </Fragment>

    );

    const submitSuccessMessage = (
        <Fragment>
        <div className={classes.FormContainer}>
            <div className={classes.SubmitTitle}>
                THANKS FOR <br/>YOUR ENTRY
            </div>
            <div className={classes.Separator}></div>
            <div className={classes.SubmitDescription} style={{height: 'auto'}}>
                <p></p> 
                <p></p>
            </div>
            {followButton}
        </div>

        {/* {footer} */}
        </Fragment>
    );

    return (
        <Fragment>
            { !formSubmit && !submitSuccess && emailSubmitFormContainer }
            { formSubmit && alreadySubscribed && alreadyEntered }
        </Fragment>
    );
}

export default EmailSubmit;
